// extracted by mini-css-extract-plugin
var _1 = "ProductContainer_container__-FoBD";
var _2 = "ProductContainer_horRule__bQw8F hor-rule";
var _3 = "ProductContainer_productContainer__LiY-j";
export { _1 as "container", _2 as "horRule", _3 as "productContainer" }
